export enum DocumentsFormFieldNames {
  Kbis = 'kbis',
  Cni = 'cni',
  RIB = 'rib',
  Documents = 'documents',
}
